<template lang="pug">
.container-action-button-confirmation.center
  .container-message
    h3 Confirmación
    .text {{ textConfirmation }} ¿Deseas continuar?
    .buttons
      shActionButton(:action="close" text="No" textRunning="No")
      shActionButton(:action="accept" text="Sí" textRunning="Sí" :principalColor="true")
</template>

<script>
export default {
  name: 'ActionButtonConfirmation',

  props: {
    textConfirmation: { type: String, default: '' }
  },

  components: { shActionButton: () => import('@/components/elements/ActionButton') },

  mounted () {
    this.moveToBody()
  },

  destroyed () {
    this.removeFromBody()
  },

  methods: {
    moveToBody () {
      if (!this.$el || this.$el.nodeType !== 1) return
      if (this.$el.parentNode !== document.body) {
        document.body.appendChild(this.$el)
      }
    },

    removeFromBody () {
      if (this.$el && this.$el.nodeType === 1 && this.$el.parentNode === document.body) {
        document.body.removeChild(this.$el)
      }
    },

    close () {
      this.$emit('close')
    },
    accept () {
      this.$emit('accept')
    }
  }
}
</script>

<style lang="stylus">
@import '~@/stylus/functions.styl'

.container-action-button-confirmation
  position fixed
  width 100%
  height 100%
  left 0
  top 0
  background-color rgba(0, 0, 0, .4)
  z-index 12000
  display flex
  justify-content center
  align-items center

.container-message
  background-color var(--background-principal)
  padding 2em 3em
  borderRadius(.5em)
  width 100%
  max-width 40em

.container-message .text
  margin .5em 0 1em 0
  font-size 1.1em

.container-message .buttons
  display flex
  justify-content center
  align-items center
  gap 1em
</style>



// WEBPACK FOOTER //
// src/components/elements/ActionButtonConfirmation.vue